import moment from "moment";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MaterialTable, { MTableToolbar } from "material-table";
import { ToastContainer, toast } from "react-toastify";
import CreateTicket from "./components/createTicket.js";
import { useTickets } from './components/TicketContext.js';
import TicketService from '../../services/ticketing/TicketingServices';
import { getTrans as t } from "../../Localization/translations";
import GetCompanyInfoService from '../../services/company/getCompanyInfoService';
import { API } from "../../backend.js";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import Select from "react-select";
import axios from "axios";

const statusColors = {
  closed: "bg-danger text-white",
  resolved: "bg-success text-white",
  escalated: "bg-danger bg-gradient text-white",
  open: "bg-info text-dark",
  new: "bg-light text-dark",
  replied: "bg-warning text-dark",
  "waiting-user": "bg-secondary text-white",
  "waiting-support": "bg-secondary text-white",
  deleted: "bg-secondary text-white",
  watchlist: "bg-secondary text-white",
};

const priorityColors = {
  critical: "bg-danger text-white",
  high: "bg-warning text-dark",
  medium: "bg-info text-dark",
  low: "bg-success text-white",
  normal: "bg-light text-dark",
};

const getStatusClass = (status) => {
  switch (status) {
    case "new": return "badge bg-info text-dark";
    case "open": return "badge bg-success";
    case "closed": return "badge bg-danger";
    case "resolved": return "badge bg-success";
    case "replied": return "badge bg-warning text-dark";
    default: return "badge bg-secondary";
  }
};



const priorityOptions = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "critical", label: "Critical" },
];

const statusOptions = [
  { value: "new", label: "New" },
  { value: "open", label: "Open" },
  // { value: "in-progress", label: "In Progress" },
  // { value: "waiting-user", label: "Waiting for User" },
  // { value: "waiting-support", label: "Waiting for Support" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
  // { value: "escalated", label: "Escalated" },
];

export default function DashboardPage() {
  const navigate = useNavigate();
  const { tickets, stats, actions, loading, error } = useTickets();
  const [showCreateTicket, setShowCreateTicket] = useState(false);
  const tableTicketRef = React.createRef();
  // Get user data from main application
  const userData = JSON.parse(localStorage.getItem('user'));
  const [currentUser] = useState({
    email: userData?.username || userData?.email || "user@company.com",
    company: userData?.companyName || "Company",
    user_id: userData?.user_id
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("my-tickets");
  const [fullCompanyName, setFullCompanyName] = useState("");
  const [ticketsData, setTicketsData] = useState([]);
  const [dataLoading, setDataLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);

  // Filter sliding pane UI state
  const [paneOpen, setPaneOpen] = useState(false);

  // Filter states
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerInputValue, setCustomerInputValue] = useState("");
  const [isLoadingCustomer, setIsLoadingCustomer] = useState(false);

  const [selectedPriority, setSelectedPriority] = useState(null);

  const [selectedStatus, setSelectedStatus] = useState(null);

  const [selectedCreationDate, setSelectedCreationDate] = useState("");

  const [selectedAssignedTo, setSelectedAssignedTo] = useState(null);
  const [assignedToOptions, setAssignedToOptions] = useState([]);
  const [assignedToInputValue, setAssignedToInputValue] = useState("");
  const [isLoadingAssignedTo, setIsLoadingAssignedTo] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      try {
        // Run both API calls in parallel to avoid loading state conflicts
        await Promise.all([
          actions.fetchTickets(),
          actions.fetchStats()
        ]);
      } catch (err) {
        //console.error('Error loading dashboard data:', err);
      }
    };
    loadData();
  }, []);

  // Fetch full company details
  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await GetCompanyInfoService.getCompanyInfo();
        console.log('User page - Company info response:', response.data);

        // Extract full company name from the response
        // Adjust these field names based on what your API actually returns
        const companyData = response.data;
        const fullName = companyData.company_name ||
          companyData.name ||
          companyData.full_name ||
          companyData.business_name ||
          companyData.legal_name ||
          "Company Name Not Available";

        setFullCompanyName(fullName);
      } catch (err) {
        console.error('Error fetching company details:', err);
        setFullCompanyName("Company Name Unavailable");
      }
    };

    fetchCompanyDetails();
  }, []);

  // API helper to fetch tickets
  const fetchTickets = async (filters = {}) => {
    setDataLoading(true);
    setFetchError(null);
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const headers = {
        Authorization: `Bearer ${user?.access || user?.token}`,
      };

      // Build query params
      let params = [];
      if (filters.customerName)
        params.push(
          `customer_name=${encodeURIComponent(filters.customerName)}`
        );
      if (filters.priority)
        params.push(`priority=${encodeURIComponent(filters.priority)}`);
      if (filters.status) {
        if (filters.status === "escalated") {
          params.push("is_escalated=true");
        } else {
          params.push(`status=${encodeURIComponent(filters.status)}`);
        }
      }
      if (filters.creationDate)
        params.push(`created_before=${encodeURIComponent(filters.creationDate)}`);
      if (filters.assignedTo)
        params.push(
          `assigned_to=${encodeURIComponent(filters.assignedTo)}`
        );

      params.push("per_page=1000");
      params.push("page=1");
      const queryString = params.length ? `?${params.join("&")}` : "";
      const url = `${API}ticket/tickets/${queryString}`;

      const response = await axios.get(url, { headers });
      setTicketsData(
        response.data.data ||
        response.data.results ||
        response.data.tickets ||
        []
      );
    } catch (err) {
      setFetchError("Error fetching tickets. Please try again.");
      setTicketsData([]);
    } finally {
      setDataLoading(false);
    }
  };

  // Initial fetch: all tickets
  useEffect(() => {
    fetchTickets({});
  }, []);

  // Filter: Apply filters via API
  const handleApplyFilters = () => {
    const filters = {
      customerName:
        selectedCustomer && (selectedCustomer.name || selectedCustomer.client_name),
      priority: selectedPriority && selectedPriority.value,
      status: selectedStatus && selectedStatus.value,
      creationDate: selectedCreationDate,
      assignedTo:
        selectedAssignedTo &&
        (selectedAssignedTo.id || selectedAssignedTo.email || selectedAssignedTo.assigned_to_email),
    };
    fetchTickets(filters);
    setPaneOpen(false);
  };

  // Filter: Clear filters (fetch all)
  const handleClearFilters = () => {
    setSelectedCustomer(null);
    setSelectedPriority(null);
    setSelectedStatus(null);
    setSelectedCreationDate("");
    setSelectedAssignedTo(null);
    fetchTickets({});
  };

  // Customer options (search from local tickets)
  const handleCustomerInputChange = (value) => {
    setCustomerInputValue(value);
    setIsLoadingCustomer(true);
    // Build unique list of customers from current tickets
    const customers = [];
    const seen = new Set();
    ticketsData.forEach((ticket) => {
      const email = ticket.client_name;
      const name = ticket.created_by_name;
      if (
        email &&
        !seen.has(email) &&
        (!value ||
          email.toLowerCase().includes(value.toLowerCase()) ||
          (name && name.toLowerCase().includes(value.toLowerCase())))
      ) {
        seen.add(email);
        customers.push({
          customer_name: name || email,
          email: email,
          client_name: email,
        });
      }
    });
    setCustomerOptions(customers.slice(0, 20));
    setIsLoadingCustomer(false);
  };

  // Assigned To options (search from local tickets)
  const handleAssignedToInputChange = (value) => {
    setAssignedToInputValue(value);
    setIsLoadingAssignedTo(true);
    const assigned = [];
    const seen = new Set();
    ticketsData.forEach((ticket) => {
      const assignedEmail = ticket.assigned_to_email || ticket.assigned_to_name;
      const assignedName = ticket.assigned_to_name || ticket.assigned_to_name;
      if (
        assignedEmail &&
        !seen.has(assignedEmail) &&
        (!value ||
          assignedEmail.toLowerCase().includes(value.toLowerCase()) ||
          (assignedName && assignedName.toLowerCase().includes(value.toLowerCase())))
      ) {
        seen.add(assignedEmail);
        assigned.push({
          assigned_name: assignedName || assignedEmail,
          email: assignedEmail,
          assigned_to_email: assignedEmail,
          id: ticket.assigned_to, // for filtering by id
        });
      }
    });
    setAssignedToOptions(assigned.slice(0, 20));
    setIsLoadingAssignedTo(false);
  };

  // Filter tickets by tab (statusFilter)
  const getFilteredTickets = () => {
    if (!Array.isArray(ticketsData)) return [];
    if (statusFilter === "my-tickets") {
      return ticketsData;
    } else if (statusFilter === "watchlist") {
      return ticketsData.filter((ticket) => ticket.is_watchlist === true || ticket.is_escalated === true);
    } else {
      return ticketsData.filter(
        (ticket) =>
          ticket.status &&
          ticket.status.toLowerCase() === statusFilter.toLowerCase()
      );
    }
  };

  const filteredTickets = getFilteredTickets();

  const dashboardStats = stats.status_stats || {
    total: filteredTickets.length,
    new: filteredTickets.filter(t => t.status === "new").length,
    open: filteredTickets.filter(t => t.status === "open").length,
    closed: filteredTickets.filter(t => t.status === "closed").length,
    resolved: filteredTickets.filter(t => t.status === "resolved").length,
  };

  if (dataLoading || loading) {
    return (
      <div className="bg-light min-vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <div className="spinner-border text-secondary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading tickets...</p>
        </div>
      </div>
    );
  }

  // if (fetchError || error) {
  //   return (
  //     <div className="bg-light min-vh-100 d-flex justify-content-center align-items-center">
  //       <div className="text-center">
  //         <div className="alert alert-danger" role="alert">
  //           <h4 className="alert-heading">Error!</h4>
  //           <p>{fetchError || error}</p>
  //           <button className="btn btn-primary" onClick={() => {
  //             fetchTickets({});
  //             actions.fetchTickets();
  //             actions.fetchStats();
  //           }}>
  //             Retry
  //           </button>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div className="container-fluid bg-light min-vh-100 p-2">
      <main>

        <div className="d-flex justify-content-end pt-2">
          <button className="btn btn-primary" onClick={() => setShowCreateTicket(true)}>
            + Create New Ticket
          </button>
        </div>

        {!showCreateTicket && (
          <div className="d-flex flex-wrap justify-content-between mb-4">
            {[
              { label: "Total", value: dashboardStats.total, color: "text-primary" },
              { label: "New", value: dashboardStats.new, color: "text-info" },
              { label: "Open", value: dashboardStats.open, color: "text-success" },
              { label: "Resolved", value: dashboardStats.resolved, color: "text-success" },
              { label: "Closed", value: dashboardStats.closed, color: "text-danger" },
            ].map((stat) => (
              <div className="flex-fill mx-2 mb-3 pt-4" key={stat.label} style={{ minWidth: "150px" }}>
                <div className="card text-center shadow-sm">
                  <div className="card-body">
                    <div className="card-title text-muted text-uppercase small">{stat.label}</div>
                    <div className="hyperlink" style={{ fontSize: "30px" }}>{stat.value}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}


        {/* Create Ticket Button */}
        {/* <div className="d-flex justify-content-end mb-3">
          <button className="btn btn-primary" onClick={() => setShowCreateTicket(true)}>
            + Create New Ticket
          </button>
        </div> */}

        {/* Inline Create Ticket Form */}
        {showCreateTicket && (
          <div className="mb-4">
            <CreateTicket
              open={showCreateTicket}
              onClose={() => {
                setShowCreateTicket(false);
                // Refresh the tickets list after creating a new ticket
                actions.fetchTickets();
                actions.fetchStats();
                fetchTickets({});
                setTimeout(() => {
                  // if (tableTicketRef.current) {
                  //   tableTicketRef.current.onQueryChange();
                  // }
                }, 100);
              }}
              currentUser={currentUser}
              inline={true}
            />
          </div>
        )}

        {/* Filter SlidingPane */}
        <SlidingPane
          className="some-custom-class"
          overlayClassName="some-custom-overlay-class"
          isOpen={paneOpen}
          title="Filter Tickets"
          subtitle=""
          onRequestClose={() => setPaneOpen(false)}
        >
          <div className="row py-2">
            {/* Customer Name Filter */}
            <div className="col-xl-12">
              <div className="form-group row">
                <label className="col-lg-12 col-form-label">
                  {t("Customer Name")}
                </label>
                <div className="col-lg-12">
                  <Select
                    value={selectedCustomer}
                    filterOption={false}
                    options={customerOptions}
                    isClearable
                    onInputChange={handleCustomerInputChange}
                    getOptionLabel={(o) => o.customer_name || o.created_by_name}
                    getOptionValue={(o) => o.customer_name || o.created_by_name}
                    isLoading={isLoadingCustomer}
                    placeholder={t("Search for Customer Name")}
                    onChange={setSelectedCustomer}
                  />
                </div>
              </div>
            </div>

            {/* Priority Filter */}
            {/* <div className="col-xl-12">
              <div className="form-group row">
                <label className="col-lg-12 col-form-label">{t("Priority")}</label>
                <div className="col-lg-12">
                  <Select
                    value={selectedPriority}
                    options={priorityOptions}
                    isClearable
                    placeholder={t("Select Priority")}
                    onChange={setSelectedPriority}
                  />
                </div>
              </div>
            </div> */}

            {/* Status Filter */}
            <div className="col-xl-12">
              <div className="form-group row">
                <label className="col-lg-12 col-form-label">{t("Status")}</label>
                <div className="col-lg-12">
                  <Select
                    value={selectedStatus}
                    options={statusOptions}
                    isClearable
                    placeholder={t("Select Status")}
                    onChange={setSelectedStatus}
                  />
                </div>
              </div>
            </div>

            {/* Creation Date Filter */}
            <div className="col-xl-12">
              <div className="form-group row">
                <label className="col-lg-12 col-form-label">
                  {t("Creation Date (Before)")}
                </label>
                <div className="col-lg-12">
                  <input
                    type="date"
                    className="form-control"
                    value={selectedCreationDate}
                    onChange={(e) => setSelectedCreationDate(e.target.value)}
                    placeholder={t("Select date to show tickets created before this date")}
                  />
                </div>
              </div>
            </div>

            {/* Assigned To Filter */}
            <div className="col-xl-12">
              <div className="form-group row">
                <label className="col-lg-12 col-form-label">{t("Assigned To")}</label>
                <div className="col-lg-12">
                  <Select
                    value={selectedAssignedTo}
                    filterOption={false}
                    options={assignedToOptions}
                    isClearable
                    onInputChange={handleAssignedToInputChange}
                    getOptionLabel={(o) => o.assigned_name || o.email}
                    getOptionValue={(o) => o.email || o.assigned_to_email}
                    isLoading={isLoadingAssignedTo}
                    placeholder={t("Search for Assigned User")}
                    onChange={setSelectedAssignedTo}
                  />
                </div>
              </div>
            </div>

            {/* Filter Buttons */}
            <div className="col-xl-12">
              <div className="form-group row">
                <div className="col-lg-12 text-left" style={{ marginTop: "30px" }}>
                  <button
                    type="button"
                    className="clearReport btn bg-gradient-secondary ms-auto mb-0"
                    onClick={handleClearFilters}
                  >
                    {t("Reset")}
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    className="filterReport add btn btn-primary ms-auto mb-0"
                    onClick={handleApplyFilters}
                  >
                    {t("Apply")}
                  </button>
                  &nbsp;&nbsp;
                </div>
              </div>
            </div>
          </div>
        </SlidingPane>

        {/* MaterialTable - Hidden when creating ticket */}
        {!showCreateTicket && (
          <div className="container-fluid shadow-sm">
            <div className="p-2">
              <MaterialTable
                key={statusFilter} // Force re-render when status filter changes
                tableRef={tableTicketRef}
                style={{
                  backgroundColor: "var(--bs-table-bg) ",
                  borderBottomWidth: "1px",
                  boxShadow:
                    "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                }}
                title={<h5 className="mb-0">{t("")}</h5>}
                components={{
                  Toolbar: (props) => (
                    <div className="MuiToolbar-root MTableToolbar-spacer-21 my-temp-class">
                      <MTableToolbar {...props} />
                      <span
                        onClick={() => setPaneOpen(true)}
                        style={{
                          color: "#b4b7c5",
                          paddingRight: "1px",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={
                            process.env.PUBLIC_URL + "/static/images/ic-filter.svg"
                          }
                          alt="Filter"
                        />
                      </span>
                    </div>
                  ),
                }}
                columns={[
                  {
                    title: `${t("Ticket ID")}`,
                    field: "ticket_id",
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left",
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12,
                    },
                    render: (rowData) => (
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("ID")}
                        </div>
                        <div
                          className="hyperlink"
                          onClick={() => {
                            const ticketIdentifier = rowData.ticket_id || rowData.id;
                            sessionStorage.setItem('selectedTicketId', ticketIdentifier);
                            navigate(`/userticket/?ticket_id=${ticketIdentifier}`);
                           
                          }}
                        >
                          {rowData.ticket_id || rowData.id}
                        </div>
                      </>
                    ),
                  },
                  {
                    title: `${t("Subject")}`,
                    field: "title",
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left",
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12,
                    },
                    render: (rowData) => (
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("Subject")}
                        </div>
                        <div>{rowData.title}</div>
                      </>
                    ),
                  },
                  {
                    title: `${t("Assigned To")}`,
                    field: "company_name",
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left",
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12,
                    },
                    render: (rowData) => (
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("Assigned To")}
                        </div>
                        <div>
                          {rowData.assigned_to_name || '-'}
                        </div>
                      </>
                    ),
                  },
                  {
                    title: `${t("User")}`,
                    field: "client_name",
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left",
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12,
                    },
                    render: (rowData) => (
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("Client")}
                        </div>
                        <div>{rowData.client_name || '-'}</div>
                      </>
                    ),
                  },
                  {
                    title: `${t("Due")}`,
                    field: "due_date",
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left",
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12,
                    },
                    render: (rowData) => (
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("Due")}
                        </div>
                        <div>{rowData.due_date ? moment(rowData.due_date).format("MM/DD/YYYY") : '-'}</div>
                      </>
                    ),
                  },
                  {
                    title: `${t("Status")}`,
                    field: "status",
                    headerStyle: {
                      verticalAlign: "inherit",
                      fontWeight: "bold",
                      textAlign: "left",
                    },
                    cellStyle: {
                      textAlign: "left",
                      fontSize: 12,
                    },
                    render: (rowData) => (
                      <>
                        <div className="d-xl-none tc d-md-none d-lg-none">
                          {t("Status")}
                        </div>
                        <span className={getStatusClass(rowData.status)}>{rowData.status_display || rowData.status}</span>
                      </>
                    ),
                  },
                  // {
                  //   title: `${t("Actions")}`,
                  //   field: "action",
                  //   headerStyle: {
                  //     verticalAlign: "inherit",
                  //     fontWeight: "bold",
                  //     textAlign: "center",
                  //   },
                  //   cellStyle: {
                  //     textAlign: "center",
                  //     fontSize: 12,
                  //   },
                  //   render: (rowData) => (
                  //     <div className="text-center">
                  //       <button
                  //         className="btn btn-sm btn-primary"
                  //         onClick={() => {
                  //           const ticketIdentifier = rowData.ticket_id;
                  //           sessionStorage.setItem('selectedTicketId', ticketIdentifier);
                  //           navigate('/userticket');
                  //         }}
                  //       >
                  //         Details
                  //       </button>
                  //     </div>
                  //   ),
                  // },
                ]}
                data={filteredTickets}
                options={{
                  headerStyle: {
                    backgroundColor: "white",
                    color: "#245C7F",
                    fontSize: 12,
                  },
                  rowStyle: (rowData, index) => {
                    if (index % 2) {
                      return { backgroundColor: "#fff" };
                    }
                  },
                  sorting: true,
                  search: true,
                  toolbar: true,
                  paging: true,
                  pageSize: 10,
                  emptyRowsWhenPaging: false,
                  pageSizeOptions: [10, 20, 25, 50],
                  paginationType: "stepped",
                  showFirstLastPageButtons: false,
                  exportAllData: true,
                  exportButton: true,
                  exportFileName: "User_Tickets",
                  actionsColumnIndex: -1,
                  columnsButton: true,
                }}
              />
            </div>
          </div>
        )}

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </main>
    </div>
  );
}